import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../../ModalContainer/ModelContainer'
import TextField from '../../../../FormLegacy/FormFieldsV2/TextField'
import RadioField from '../../../../FormLegacy/FormFieldsV2/RadioField'
import ToggleField from '../../../../FormLegacy/FormFieldsV2/ToggleField'

const getPetFormFields = (t) => [
  {
    id: 'name',
    label: t('checklists-create-task:realPageForm.fields.petName'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'breed',
    label: t('checklists-create-task:realPageForm.fields.breed'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'age',
    label: t('checklists-create-task:realPageForm.fields.age'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 20,
    },
    dataType: 'String',
  },
  {
    id: 'color',
    label: t('checklists-create-task:realPageForm.fields.color'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'weight',
    label: t('checklists-create-task:realPageForm.fields.weight'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 8,
    },
    dataType: 'String',
  },
  {
    id: 'petRent',
    label: t('checklists-create-task:realPageForm.fields.petRent'),
    type: 'single_choice',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.singleChoice'),
    options: [t('common:booleans.yes'), t('common:booleans.no')],
    required: true,
    dataType: 'Boolean',
  },
  {
    id: 'notes',
    label: t('checklists-create-task:realPageForm.fields.notes'),
    type: 'long_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.longAnswer'),
    required: false,
    validation: {
      maxLength: 255,
    },
    dataType: 'String',
  },
]

const getVehicleFormFields = (t) => [
  {
    id: 'modelYear',
    label: t('checklists-create-task:realPageForm.fields.modelYear'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: true,
    validation: {
      maxLength: 4,
      pattern: '^\\d{4}$',
    },
    dataType: 'Integer',
  },
  {
    id: 'make',
    label: t('checklists-create-task:realPageForm.fields.make'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'model',
    label: t('checklists-create-task:realPageForm.fields.model'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'licensePlate',
    label: t('checklists-create-task:realPageForm.fields.licensePlate'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'color',
    label: t('checklists-create-task:realPageForm.fields.color'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'stateCode',
    label: t('checklists-create-task:realPageForm.fields.stateCode'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 8,
    },
    dataType: 'String',
  },
  {
    id: 'parkingAssignment',
    label: t('checklists-create-task:realPageForm.fields.parkingAssignment'),
    type: 'short_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.shortAnswer'),
    required: false,
    validation: {
      maxLength: 30,
    },
    dataType: 'String',
  },
  {
    id: 'notes',
    label: t('checklists-create-task:realPageForm.fields.notes'),
    type: 'long_answer',
    typeLabel: t('checklists-create-task:realPageForm.inputTypes.longAnswer'),
    required: false,
    validation: {
      maxLength: 255,
    },
    dataType: 'String',
  },
]

const RealPageFormModal = ({ onClose, type }) => {
  const { t } = useTranslation(['checklists-create-task', 'common'])
  const formFields = type === 'pet' ? getPetFormFields(t) : getVehicleFormFields(t)
  return (
    <ModalContainer
      additionalClass="realpage-form-modal"
      onClose={onClose}
      headerTitle={
        type === 'pet'
          ? t('checklists-create-task:realPageForm.petHeaderTitle')
          : t('checklists-create-task:realPageForm.vehicleHeaderTitle')
      }
    >
      <div className="realpage-form-modal-content">
        {formFields.map((field) => (
          <div key={field.id} className="realpage-form-modal-content__field">
            <div className="realpage-form-modal-content__input-row">
              <TextField
                label={t('checklists-create-task:dataInput.taskItemLabelLabel')}
                value={field.label}
                disabled
              />
              <TextField
                name="short-answer"
                label={t('checklists-create-task:realPageForm.inputTypeLabel')}
                value={field.typeLabel}
                disabled
              />
            </div>

            {field.type === 'single_choice' && (
              <div className="realpage-form-modal-content__radio-fields">
                {field.options.map((radioInput) => (
                  <RadioField
                    additionalClass="realpage-form-modal-content__radio-field"
                    key={radioInput}
                    label={radioInput}
                    checked={false}
                    disabled
                  />
                ))}
              </div>
            )}
            <ToggleField
              label={t('checklists-create-task:dataInput.requiredLabel')}
              labelOnRight
              value={field.required}
              disabled
            />
          </div>
        ))}
      </div>
    </ModalContainer>
  )
}

RealPageFormModal.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.string,
}

export default RealPageFormModal
